require("./quill");

export class RichEditor {
  quill;
  configresions;
  editor;
  userId;
  defaultConfigresions = {
    toolbar: '.toolbar',
    visualEditor: '.visual_editor',
    toolbarImageUpload: '.image-upload',
    uploadImageToolbox: '.upload-box',
    uploadImageToolboxDropArea: '.upload-drop-area',
    uploadImageToolboxUploadFile: '.upload-box__upload-file',
    uploadImageToolboxGallery: '.gallery',
    uploadImageToolboxSelectItem: '.select-image',
    uploadImageToolboxGalleryPagenate: '.gallery-pagenate',
    uploadImageToolboxReload: '.reload-image',
    toolbarTable: '.insert-table',
    tableToolbox: '.table-box',
    tableToolBoxEntrySelectLabel: '.entry-select-label',
    tableToolBoxEntrySelect: '.entry-select',
    toolbarFileUpload: '.file-upload',
    fileToolbox: '.file-box',
    fileToolboxDropArea: '.file-drop-area',
    fileToolboxUploadFile: '.file-box__upload-file',
    fileToolboxFileList: '.file-list-box',
    fileToolboxSelectItem: '.select-file',
    fileToolboxFilePagenate: '.file-pagenate',
    fileToolboxReload: '.reload-file',
    
    toolbarVisualEditor: '.visual-view',
    toolbarPreview: '.preview-view',
    previewBox: '.editor_preview',
  };
  urls;

  constructor(target, defaultText, userId, urls, containerName, configresions ) {
    this.userId = userId;
    this.urls = urls;

    if ( configresions ) {
      this.configresions = configresions;
    }
    else {
      this.configresions = new Object();
      for ( let key in this.defaultConfigresions ) {
        this.configresions[key] = '.' + containerName + ' ' + this.defaultConfigresions[key];
      }
    }

    this.quill = new Quill(target, {
      theme: 'snow',
      modules: {
        toolbar: this.configresions.toolbar,
        table: true,
        'better-table': {
          operationMenu: {
            items: {
              unmergeCells: {
                text: 'Unmerge cells'
              }
            },
            color: {
              colors: ['green', 'red', 'yellow', 'blue', 'white'],
              text: 'Background Colors:'
            }
          }
        },
      },
    });


    $(this.configresions.visualEditor).css({
      'height': $(target).height() + 'px', 
      'width': '100%',
    });
    $(this.configresions.previewBox).css({
      'height': $(target).height() + 'px', 
      'width': '100%',
    });
    
    this.editor = ace.edit(document.querySelector(this.configresions.visualEditor));
    this.editor.setTheme("ace/theme/tomorrow");
    this.editor.setFontSize(14);
    this.editor.getSession().setMode("ace/mode/html");
    this.editor.getSession().setUseWrapMode(true);
    this.editor.getSession().setTabSize(2);
    this.editor.setValue(defaultText);

    this.bindEvents();

    this.loadImages(null);
    this.loadFiles(null);

    document.querySelector('.' + containerName).editor = this;
  }

  bindEvents() {
    let self = this;

    $(this.configresions.toolbarImageUpload).on('click', function() {
      if ($(self.configresions.uploadImageToolbox).hasClass('hide')) {
        $(self.configresions.uploadImageToolbox).css({
          'top': ($(this).offset().top - $(self.configresions.toolbar).offset().top + 35) + 'px',
          'left': ($(this).offset().left - $(self.configresions.toolbar).offset().left - 142) + 'px',
          'z-index': 100
        });
  
        $(self.configresions.uploadImageToolbox).removeClass('hide');
      } 
      else {
        $(self.configresions.uploadImageToolbox).addClass('hide');
      }

      return false;
    });

    $(document).on('click', (e) => {
      if (!$(e.target).closest(self.configresions.uploadImageToolbox).length 
        && !$(e.target).closest(self.configresions.toolbarImageUpload).length) {
        $(self.configresions.uploadImageToolbox).addClass('hide');
      }
      
      if (!$(e.target).closest(self.configresions.tableToolbox).length 
        && !$(e.target).closest(self.configresions.toolbarTable).length) {
        $(self.configresions.tableToolbox).addClass('hide');
      }
  
      if (!$(e.target).closest(self.configresions.fileToolbox).length 
        && !$(e.target).closest(self.configresions.toolbarFileUpload).length) {
        $(self.configresions.fileToolbox).addClass('hide');
      }
    });

    $(self.configresions.uploadImageToolboxDropArea).on('dragover', function(e) {
      e.preventDefault();
      this.classList.add('dragover');
    });

    $(self.configresions.uploadImageToolboxDropArea).on('dragleave', function(e) {
      e.preventDefault();
      this.classList.add('dragover');
    });

    $(self.configresions.uploadImageToolboxDropArea).on('drop', function(e) {
      e.preventDefault();
      this.classList.remove('dragover');
  
      $(self.configresions.uploadImageToolboxUploadFile)[0].files = e.originalEvent.dataTransfer.files;
  
      self.uploadFileImage($(self.configresions.uploadImageToolboxUploadFile)[0].files);
  
      $(self.configresions.uploadImageToolbox).addClass('hide');
    });
  
    $(this.configresions.uploadImageToolboxUploadFile).on('change', function() {
      let files = $(this)[0].files;
      self.uploadFileImage(files);
  
      $(self.configresions.uploadImageToolbox).addClass('hide');
    });

    $(document).on('click', this.configresions.uploadImageToolboxSelectItem, function() {
      let val = $(this).data('value');
      var range = self.quill.getSelection();
      self.quill.insertEmbed(range ? range.index : 0, 'image', val, Quill.sources.USER);
  
      $(self.configresions.uploadImageToolbox).addClass('hide');
      return false;
    });

    $(document).on('click', this.configresions.uploadImageToolboxGalleryPagenate + ' a', function() {
      let href = $(this).prop('href');
      self.loadImages(href);
      return false;
    });

    $(document).on('click', this.configresions.uploadImageToolboxReload, function() {
      self.loadImages(null);
      return false;
    });

    $(this.configresions.toolbarTable).on('click', function() {
      if ($(self.configresions.tableToolbox).hasClass('hide')) {
        $(self.configresions.tableToolbox).css({
          'top': (($(this).offset().top - $(self.configresions.toolbar).offset().top) + 35) + 'px',
          'left': (($(this).offset().left - $(self.configresions.toolbar).offset().left) - 63) + 'px',
          'z-index': 100
        });
  
        $(self.configresions.tableToolbox).removeClass('hide');
      } 
      else {
        $(self.configresions.tableToolbox).addClass('hide');
      }
  
      return false;
    });

    $(this.configresions.tableToolBoxEntrySelect).on('mouseover', function (e) {
      $(self.configresions.tableToolBoxEntrySelect).removeClass('active');
  
      let curRowIndex = $(this).data('row');
      let curColIndex = $(this).data('col');
  
      $(self.configresions.tableToolBoxEntrySelectLabel).text((curRowIndex + 1) + '行' + (curColIndex + 1) + '列');
  
      $(self.configresions.tableToolBoxEntrySelect).each(function(ix, obj) {
        let rowIndex = $(obj).data('row');
        let colIndex = $(obj).data('col');
  
        if (rowIndex <= curRowIndex && colIndex <= curColIndex) {
          $(obj).addClass("active");
        }
      });
      return false;
    });

    $(this.configresions.tableToolBoxEntrySelect).on('click', function (e) {
      let curRowIndex = $(this).data('row');
      let curColIndex = $(this).data('col');
  
      let module = self.quill.getModule('better-table');
      module.insertTable(curRowIndex + 1, curColIndex + 1);
  
      $(this.configresions.tableToolBoxEntrySelect).removeClass('active');
      $(this.configresions.tableToolbox).addClass('hide');
      $(this.configresions.tableToolBoxEntrySelectLabel).text('');
  
      return false;
    });

    $(this.configresions.toolbarFileUpload).on('click', function() {
      if ( $(self.configresions.fileToolbox).hasClass('hide')) {
        $(self.configresions.fileToolbox).css({
          'top': ($(this).offset().top - $(self.configresions.toolbar).offset().top + 35) + 'px',
          'left': ($(this).offset().left - $(self.configresions.toolbar).offset().left - 142) + 'px',
          'z-index': 100
        });
        $(self.configresions.fileToolbox).removeClass('hide');
      } 
      else {
        $(self.configresions.fileToolbox).addClass('hide');
      }
      return false;
    });

    $(this.configresions.fileToolboxDropArea).on('dragover', function(e) {
      e.preventDefault();
      this.classList.add('dragover');
    });

    $(this.configresions.fileToolboxDropArea).on('dragleave', function(e) {
      e.preventDefault();
      this.classList.add('dragover');
    });

    $(this.configresions.fileToolboxDropArea).on('drop', function(e) {
      e.preventDefault();
      this.classList.remove('dragover');
  
      $(self.configresions.fileToolboxUploadFile)[0].files = e.originalEvent.dataTransfer.files;
  
      self.uploadFile($('.file-box .upload-file')[0].files);
  
      $(self.configresions.fileToolbox).addClass('hide');
    });
  
    $(self.configresions.fileToolboxUploadFile).on('change', function() {
      let files = $(this)[0].files;
      self.uploadFile(files);
  
      $(self.configresions.fileToolbox).addClass('hide');
    });

    $(document).on('click', this.configresions.fileToolboxSelectItem, function() {
      let url = $(this).data('url');
      var range = self.quill.getSelection();
      if ( !range ) {
        $(self.configresions.fileToolbox).addClass('hide');
        return;
      }
      self.quill.setSelection(range.index, range.length);
      self.quill.theme.tooltip.edit('link', url);
      self.quill.theme.tooltip.save();
  
      $(self.configresions.fileToolbox).addClass('hide');
      return false;
    });

    $(document).on('click', this.configresions.fileToolboxFilePagenate + ' a', function() {
      let href = $(this).prop('href');
      self.loadFiles(href);
      return false;
    });

    $(this.configresions.toolbarVisualEditor).on('click', function() {
      if ( $(self.configresions.visualEditor).hasClass('hide')) {
        $(self.configresions.visualEditor).css({
          'z-index': 99
        });
  
        $(self.configresions.visualEditor).removeClass('hide');
        $(self.configresions.toolbarVisualEditor).addClass('active');
        self.editor.setValue(self.quill.root.innerHTML);
      } 
      else {
        $(self.configresions.visualEditor).addClass('hide');
        self.quill.container.firstChild.innerHTML = self.editor.getValue();
        $(self.configresions.toolbarVisualEditor).removeClass('active');
      }
  
      return false;
    });

    $(document).on('click', this.configresions.fileToolboxReload, function() {
      self.loadFiles(null);
      return false;
    });

    $(this.configresions.toolbarPreview).on('click', function() {
      if ( $(self.configresions.previewBox).hasClass('hide')) {
        $(self.configresions.previewBox).css({
          'z-index': 98
        });
  
        $(self.configresions.previewBox).removeClass('hide');
        $(self.configresions.toolbarPreview).addClass('active');
        $(self.configresions.previewBox).html(self.quill.root.innerHTML);
      } 
      else {
        $(self.configresions.previewBox).addClass('hide');
        $(self.configresions.toolbarPreview).removeClass('active');
      }
  
      return false;
    });
  }

  uploadFileImage(files) {
    if (!files || files.length == 0) {
      return;
    }
    var range = this.quill.getSelection();
    var fd = new FormData();
    fd.append("upfile", files[0]);
    fd.append("user_id", this.userId);

    let self = this;
    $.ajax({
      url: this.urls.editorUploadImage,
      type: 'post',
      data: fd,
      processData: false,
      contentType: false,
      cache: false,
      beforeSend: function() {
        openOverlay();
      }
    }).done(function(data) {
      self.quill.insertEmbed(range ? range.index : 0, 'image', data.image_url, Quill.sources.USER);
      self.loadImages(null);
    }).fail(function(e) {
      toastr.error("画像のアップロードに失敗しました。");
    }).always(function(data) {
      closeOverlay();
    });
  }
  
  loadImages(url) {
    let url2 = url ? url : this.urls.editorImageList;
    
    let self = this;
    $.ajax({
      url: url2,
      type: 'post',
      data: null,
    }).done(function(data) {
      $(self.configresions.uploadImageToolboxGallery).html(data);
    }).fail(function(e) {
      console.log(e);
    });
  }

  uploadFile(files) {
    if (!files || files.length == 0) {
      return;
    }
    var range = this.quill.getSelection();
    var fd = new FormData();
    fd.append("upfile", files[0]);
    fd.append("user_id", this.userId);
    
    let self = this;
    $.ajax({
      url: this.urls.fileUpload,
      type: 'post',
      data: fd,
      processData: false,
      contentType: false,
      cache: false,
      beforeSend: function() {
        openOverlay();
      }
    }).done(function(data) {
      self.loadFiles(null);
    }).fail(function(e) {
      toastr.error("添付ファイルのアップロードに失敗しました。");
    }).always(function(data) {
      closeOverlay();
    });
  }

  loadFiles(url) {
    let url2 = url ? url : this.urls.fileList;
    
    let self = this;
    $.ajax({
      url: url2,
      type: 'post',
      data: null,
    }).done(function(data) {
      $(self.configresions.fileToolboxFileList).html(data);
    }).fail(function(e) {
      console.log(e);
    });
  }

  getText() {
    return this.quill.root.innerHTML;
  }
}